import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=1f64ffbe&scoped=true"
import script from "./evaluateList.vue?vue&type=script&lang=js"
export * from "./evaluateList.vue?vue&type=script&lang=js"
import style0 from "./evaluateList.vue?vue&type=style&index=0&id=1f64ffbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64ffbe",
  null
  
)

export default component.exports